/** 与 backend app.routers.admin_console 中监管任务展示一致；前端兜底以防接口未升级或未重启。 */

const JOB_LABEL_ZH: Record<string, string> = {
  openfda_ingest: "FDA 执法同步（openFDA）",
  ftc_rss_ingest: "FTC RSS 抓取入库",
  regulatory_dispatch_alerts: "监管邮件派发",
};

const SUMMARY_METRIC_ZH: Record<string, string> = {
  inserted: "新增入库",
  updated: "更新",
  endpoint_errors: "接口错误",
  feed_errors: "Feed 错误",
  emails_sent: "已发邮件",
  items_recorded: "派发记录",
  send_errors: "发送错误",
};

export function jobLabelZh(jobKey: string): string {
  return JOB_LABEL_ZH[jobKey] ?? jobKey;
}

/** 将 summary 的 key=value 转为中文指标名；无法解析时返回 null */
export function jobSummaryToZh(summary: string | null | undefined): string | null {
  if (summary == null || !String(summary).trim()) return null;
  const s = String(summary).trim();
  const chunks: string[] = [];
  for (const part of s.split(/\s+/)) {
    if (!part.includes("=")) continue;
    const eq = part.indexOf("=");
    const k = part.slice(0, eq).trim();
    const v = part.slice(eq + 1);
    const label = SUMMARY_METRIC_ZH[k] ?? k;
    chunks.push(`${label} ${v}`);
  }
  if (!chunks.length) return null;
  return chunks.join("，");
}
